<template>
	<div
	v-if="show_nav"
	:class="scroll_bottom ? 'navbar-small' : ''"
	class="cont-nav">
		<b-navbar 
		toggleable="lg" 
		type="dark">
			<brand-btn></brand-btn>

			<buscador
			v-if="show_nav_content && !is_mobile"></buscador>	
			
			<right-buttons
			v-if="show_nav_content"></right-buttons>
			
			<info-compra-segura
			v-if="!show_nav_content"></info-compra-segura>
		</b-navbar>
		
		<footer-nav></footer-nav>
		
		<mobile></mobile>

		<!-- Sidebars fuera del footer y del menú móvil para evitar display:none y anidamiento al scrollear -->
		<nav-categories></nav-categories>
		<nav-bodegas></nav-bodegas>
		<nav-cepas></nav-cepas>
		<nav-marcas></nav-marcas>
	</div>
</template>
<script>
export default {
	data() {
		return {
			scroll: 0,
			scroll_bottom: false,
		}
	},
	created() {
		window.addEventListener('scroll', () => {
			if (this.scroll < window.scrollY) {
				if (window.scrollY >= 30) {
					this.scroll_bottom = true
				}
			} else {
				this.scroll_bottom = false
			} 
			this.scroll = window.scrollY
		})
	},
	components: { 
		BrandBtn: () => import('@/components/nav/BrandBtn'),
		RightButtons: () => import('@/components/nav/right-buttons/Index'),
		InfoCompraSegura: () => import('@/components/nav/InfoCompraSegura'),
		FooterNav: () => import('@/components/nav/footer/Index'),
		Buscador: () => import('@/components/nav/buscador/Index'),			
		Mobile: () => import('@/components/nav/Mobile'),
		NavCategories: () => import('@/components/nav/categories/Index'),
		NavBodegas: () => import('@/components/nav/bodegas/Index'),
		NavCepas: () => import('@/components/nav/cepas/Index'),
		NavMarcas: () => import('@/components/nav/marcas/Index'),
	},
	computed: {
        show_nav() {
            return this.route_name != 'Maps'
        },
	},
}
</script>
<style lang="sass">
@import '@/sass/_custom.scss'
.cont-nav 
	position: fixed
	top: 0
	left: 0
	width: 100%
	z-index: 100

.navbar-small
	.navbar 
		height: 60px !important
	.footer-nav
		display: none
	.navbar-brand
		img 
			width: 50px !important

.navbar

	@if ($theme == dark) 
		background: #111111
		.nav-link
			color: red !important
	@else if ($theme == ligth) 
		background: $green

	transition: height 0.25s ease-in
	
	height: 90px

	padding: .3em 15px
	display: flex
	justify-content: center !important

	// Estilos para link de escritrio
	.navbar-nav 
		align-items: center
		// .aa
		// 	&:hover
		// 		color: $green
		// 		text-decoration: none
	.notification
		position: absolute
		top: 30%
		right: 0px

</style>